// Zone flags and early polyfills
// This file is loaded before zone.js

// Comprehensive CommonJS polyfills - must be loaded before any other code
if (typeof window !== 'undefined') {
    // Ensure global is available
    (window as any).global = window;

    // Global module/exports make jasmine.js take its CommonJS branch and skip
    // creating window.jasmineRequire, which breaks Karma's boot.js — keep
    // these shims out of test pages (context.js defines __karma__ first)
    const underKarma = !!(window as any).__karma__;

    // Create a proper exports object that can be modified
    if (!underKarma && !(window as any).exports) {
        (window as any).exports = {};
    }

    // Create a proper module object
    if (!underKarma && !(window as any).module) {
        (window as any).module = { exports: {} };
    }

    // Enhanced require function that can handle basic module resolution
    if (!(window as any).require) {
        (window as any).require = function (id: string) {
            console.warn(`require('${id}') called but not implemented`);
            return {};
        };
    }

    // Ensure process is available
    if (!(window as any).global.process) {
        (window as any).global.process = {
            env: {},
            nextTick: function (fn: Function) {
                setTimeout(fn, 0);
            }
        };
    }

    // Ensure Buffer is available (if needed)
    if (!(window as any).Buffer) {
        (window as any).Buffer = {
            isBuffer: function (obj: any) {
                return false;
            }
        };
    }
}

// Zone.js flags (if needed)
// (window as any).__Zone_disable_requestAnimationFrame = true;
// (window as any).__Zone_disable_on_property = true;
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; 